import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "UploadDocuments" })
export default class UploadDocuments extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public formData: any = { category: null, type: null, description: null, tags: [], languages: [], allowedRoles: [], uploadedFiles: [] };
    public types: any = [];
    public tags: any = [];
    public languages: any = [];
    public allowedRoles: any = [];
    public uploadedDocuments: any = [];
    public validationErrors: any[] = [];
    public isUploadPending: boolean = false;

    public uploadHeaders = { RequestVerificationToken: FormHelper.getRequestVerificationToken() };
    public uploadParameters = { fullName: "DocumentUpload" };
    public maxFileCount: number = 0;
    public maxFileSize: number = 0;
    public allowedFileExtensions: string[] = [];
    public categories: string[] = [];

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get isUploadDocumentVisible() {
        return this.$store.getters["myFileSharingStore/isUploadDocumentVisible"];
    }

    get sectionIdMaster() {
        return this.$store.getters["myFileSharingStore/sectionIdMaster"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isUploadDocumentVisible") async onUploadDocumentVisibleUpdate(newValue: boolean) {
        if (newValue) {
            await this.getData();
            document.body.classList.add("overflow");
            (<any>this).$refs.uploaddocuments.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.uploaddocuments.classList.remove("show");
        }
    }

    public async getData() {
        this.isLoading = true;

        const result = (await Axios.post(this.routes.MyBremboPartsFileSharingManagement_GetDocumentUploadData, { sectionIdMaster: this.sectionIdMaster })).data;
        this.types = result.types;
        this.tags = result.tags;
        this.languages = result.languages;
        this.allowedRoles = result.allowedRoles;
        this.maxFileCount = result.maxFileCount;
        this.maxFileSize = result.maxFileSize;
        this.allowedFileExtensions = result.allowedFileExtensions;
        this.categories = result.categories;

        this.isLoading = false;
    }

    public fileAdded() {
        this.isUploadPending = true;
    }

    public cancel() {
        this.formData.uploadedFiles = [];
    }

    public async documentsUploadCompleted(files: any) {
        if (files.length === 0) {
            this.validationErrors.push({ name: "Files", message: this.localizer.get("App.FileSharing.FilesIsRequired") });
            this.isLoadingForm = false;
            return;
        }

        this.uploadedDocuments = files;

        this.formData.uploadedFiles = this.uploadedDocuments;

        this.$store.dispatch("bremboToastStore/onAddToast", { message: this.localizer.get("App.FileSharing.UploadFilesSuccess"), type: "Success" });

        this.isUploadPending = false;

        await this.submitDocuments();
    }

    private async submitDocuments() {
        try {
            await Axios.post(this.routes.MyBremboPartsFileSharingManagement_SaveDocuments, this.formData);

            location.reload();
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public documentsUploadError(uploadingErrors: any) {
        this.validationErrors = uploadingErrors;
        this.isLoadingForm = false;
    }

    public setCategory(category: string): void {
        this.formData.category = category;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;
        this.formData.sectionName = this.$route.params.sectionName;

        if (!this.formData.category || !this.formData.type) {
            !this.formData.category ? this.validationErrors.push({ name: "Category", message: this.localizer.get("App.FileSharing.CategoryIsRequired") }) : null;

            !this.formData.type ? this.validationErrors.push({ name: "Type", message: this.localizer.get("App.FileSharing.TypeIsRequired") }) : null;

            this.isLoadingForm = false;
            return;
        }

        if (this.formData.uploadedFiles.length === 0) {
            (<any>this.$refs.childComponentRef).upload();
        } else {
            await this.submitDocuments();
        }
    }

    public setAllowedRoles() {
        if (this.formData.allowedRoles.length === 0) {
            this.formData.allowedRoles = [this.allowedRoles[0].value];
        } else {
            this.formData.allowedRoles = [];
        }
    }

    public closeDialog() {
        this.$store.commit("myFileSharingStore/setSectionIdMaster", null);
        this.$store.commit("myFileSharingStore/setUploadDocumentVisible", false);
        this.formData = { category: null, type: null, description: null, tags: [], languages: [], allowedRoles: [], uploadedFiles: [] };
        this.isLoading = false;
        this.isLoadingForm = false;
        this.validationErrors = [];
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
}